import types from './types'

export const uiReady = () => ({ type: types.UI_READY })

